module.exports = __webpack_public_path__ + "img/am-btn-shamrock-2023.6d0f6aac.png";